<div class="modal-header"><h2 class="modal-title">Online Giving Summary</h2></div>
<div class="modal-body">
  <div class="d-flex flex-fill flex-row justify-content-between">
    <div class="col-sm-4 mx-1">
      <div class="header-font">Bank/QB Amount</div>
      <div class="d-flex flex-row justify-content-between">
        <div class="last-month">Last Month Carryover Batch:</div>
        <div class="last-month">{{ amounts.lastMonth | currency }}</div>
      </div>
      <div class="d-flex flex-row justify-content-between">
        <div class="current-month">Current Month Batch:</div>
        <div class="current-month">{{ amounts.currentMonth | currency }}</div>
      </div>
      <div class="d-flex flex-row justify-content-between">
        <div class="fee-amount">Fee Amount:</div>
        <div class="fee-amount">({{ amounts.fee | currency }})</div>
      </div>
      <div class="d-flex flex-row justify-content-between">
        <div>Total:</div>
        <div>{{ amounts.bank | currency }}</div>
      </div>
    </div>

    <div class="col-sm-4 mx-1">
      <div class="header-font">Clover Amount</div>
      <div class="d-flex flex-row justify-content-between">
        <div class="current-month">Current Month Batch:</div>
        <div class="current-month">{{ amounts.currentMonth | currency }}</div>
      </div>
      <div class="d-flex flex-row justify-content-between">
        <div class="next-month">Carryover Amount:</div>
        <div class="next-month">{{ amounts.nextMonth | currency }}</div>
      </div>
      <div class="d-flex flex-row justify-content-between">
        <div>Total:</div>
        <div>{{ amounts.clover | currency }}</div>
      </div>
    </div>

    <div class="col-sm-4 mx-1">
      <div class="header-font">Month + Carryover</div>
      <div class="d-flex flex-row justify-content-between">
        <div class="current-month">Current Month Batch:</div>
        <div class="current-month">{{ amounts.currentMonth | currency }}</div>
      </div>
      <div class="d-flex flex-row justify-content-between">
        <div class="next-month">Current Month Carryover Batch:</div>
        <div class="next-month">{{ amounts.nextMonth | currency }}</div>
      </div>
      <div class="d-flex flex-row justify-content-between">
        <div class="fee-amount">Fee Amount:</div>
        <div class="fee-amount">({{ amounts.fee | currency }})</div>
      </div>
      <div class="d-flex flex-row justify-content-between">
        <div>Total:</div>
        <div>{{ amounts.qb | currency }}</div>
      </div>
    </div>
  </div>

  <div class="d-flex flex-fill flex-row justify-content-start">
    <div class="col-sm-6 mt-5 mx-1">
      <div class="header-font">Batches You Should See Created</div>
      <div class="d-flex flex-row justify-content-between">
        <div class="last-month">Last Month Carryover Batch (created last month):</div>
        <div class="last-month">{{ amounts.lastMonth | currency }}</div>
      </div>


      @for (data of amounts.lastMonthFunds; track data) {
        <div>
          <div class="d-flex flex-row justify-content-between ms-3">
            <div class="last-month">Accounts -- {{ data.name }}</div>
            <div class="last-month">{{ data.amount | currency }}</div>
          </div>
        </div>
      }





      <div class="d-flex flex-row justify-content-between mt-3">
        <div class="current-month">Current Month Batch:</div>
        <div class="current-month">{{ amounts.currentMonth | currency }}</div>
      </div>
      @for (data of amounts.funds; track data) {
        <div>
          <div class="d-flex flex-row justify-content-between ms-3">
            <div class="benevolence">Accounts -- {{ data.name }}</div>
            <div class="benevolence">{{ data.amount | currency }}</div>
          </div>
        </div>
      }





      <div class="d-flex flex-row justify-content-between mt-3">
        <div class="next-month">Carryover Amount:</div>
        <div class="next-month">{{ amounts.nextMonth | currency }}</div>
      </div>
      @for (data of amounts.nextMonthFunds; track data) {
        <div>
          <div class="d-flex flex-row justify-content-between ms-3">
            <div class="benevolence">Accounts -- {{ data.name }}</div>
            <div class="benevolence">{{ data.amount | currency }}</div>
          </div>
        </div>
      }



      <div class="d-flex flex-row justify-content-between mt-3">
        <div class="fee-amount">Fee Amount:</div>
        <div class="fee-amount">({{ amounts.fee | currency }})</div>
      </div>


      <div class="d-flex flex-row justify-content-between mt-3">
        <div class="benevolence">{{'Totals By Account (Checks to be written for ' + month + ')'}}</div>
      </div>
      @for (data of amounts.accountTotals; track data) {
        <div>
          <div class="d-flex flex-row justify-content-between ms-3">
            <div class="benevolence">Accounts -- {{ data.name }}</div>
            <div class="benevolence">{{ data.amount | currency }}</div>
          </div>
        </div>
      }


      <!-- <div class="d-flex flex-row justify-content-between mt-2">
      <div class="benevolence">Total Benevolence Online Contributions:</div>
      <div class="benevolence">{{ amounts.benevolence | currency }}</div>
    </div> -->

    @if (selectedMonth === 12) {
      <div class="d-flex flex-row justify-content-between mt-3">
        <div class="next-month">Carryover Amount Negative (December):</div>
        <div class="next-month">({{ amounts.nextMonth * -1 | currency }})</div>
      </div>
    }
    @if (selectedMonth === 12) {
      <div class="d-flex flex-row justify-content-between">
        <div class="next-month">Carryover Amount Next Year Credit (January) :</div>
        <div class="next-month">{{ amounts.nextMonth | currency }}</div>
      </div>
    }
  </div>
</div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-default" (click)="cancel()">Close</button>
</div>
